import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { HttpLoaderFactory } from '../../../app/app.module';
import { TabsPage } from './tabs';
import { GdxSegmentPageModule } from '../../../components/gdx-segment/gdx-segment.module';
import { GdxChipPageModule } from '../../gdx-chip/gdx-chip.module';
import { GdAvatarPageModule } from '../../../components/gd-avatar/gd-avatar.module';
@NgModule({
  declarations: [
    TabsPage,
  ],
  imports: [
    IonicPageModule.forChild(TabsPage),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    GdxSegmentPageModule,
    GdxChipPageModule,
    GdAvatarPageModule
  ],
  exports: [TabsPage]
})
export class TabsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/home-tabs/tabs/tabs.module.ts